import { Vue, Component, Ref, Watch } from "vue-property-decorator";
import { GridRef } from "@/components/wijmo-grid/grid/grid";
import Grid from "@/components/wijmo-grid/grid/grid.vue";
import { CommonEntitiesLocale, CommonLocale } from "@/locales/localeid";
import { fmtMsg } from "@/commonui/utils";
import { Icon, Modal } from "ant-design-vue";
import { CommonEntitiesModule } from "@/modules/common-entities";
import { TransitionModel } from "@/services/teaching-activity";
import { getModule } from "vuex-module-decorators";
import AppSettings from "@/modules/app-settings";
import { AccessLevel, ApplicationViews } from "@/util/enum";
import { VersionGroupModel } from "@/services/version-group";
import RichTextPreviewer from "@/components/rich-text-previewer/rich-text-previewer.vue";
import {disabledDueToAccessLevel, getRouteAccessLevel, pureRichText, toTimeString} from "@/util/func";
import { VersionGroupModule } from "@/modules/versiongroup";
import { TransitionServiceServerSidePagination } from "@/services/transition";

@Component({
	components: {
		Icon,
		Grid,
		RichTextPreviewer
	}
})
export default class Transitions extends Vue {
	@Ref() readonly gridCompRef!: GridRef;
	private appSettings = getModule(AppSettings);
	public CommonLocale = CommonLocale;
	public versionGroupModule = VersionGroupModule;
	public CommonEntitiesLocale = CommonEntitiesLocale;
	private CommonEntitiesModule = CommonEntitiesModule;
	public accessLevel = AccessLevel;
	transitionService = TransitionServiceServerSidePagination;
	public currentPage: number = 1;

	get transitions(): TransitionModel[] {
		return this.CommonEntitiesModule.transitions.map((tansition) => ({
			...tansition,
			title: pureRichText(tansition.text),
			versionGroupName: this.versionGroups.find((version) => version.id == tansition.versionGroupId)?.name,
			durationTimeString: toTimeString(tansition.duration)
		}));
	}

	get versionGroups(): VersionGroupModel[] {
		return CommonEntitiesModule.versionGroups;
	}

	get loading() {
		return CommonEntitiesModule.loading;
	}

	get currentRouteAccessLevel() {
		return getRouteAccessLevel(this.$route);
	}

	get disabledDueToAccessLevel() {
		return disabledDueToAccessLevel(this.currentRouteAccessLevel);
	}

	localizedString(id: string, params?: {}) {
		return fmtMsg(id, params);
	}

	toTimeString(second) {
		const sec = second % 60;
		return `${Math.floor(second / 60)}:${sec > 9 ? sec : `0${sec}`}`;
	}

	get tagDefaultSort() {
		return {
			column: "text",
			ascending: true
		};
	}

	get serviceFunc() {
		return this.transitionService.getTransitionsStatistic;
	}

	handlePaginationChange(currentPage: number) {
		this.currentPage = currentPage;
	}

	getParams() {
		return {
			isCommon: true,
			versionGroupIds: [VersionGroupModule.selectedGsVersion, VersionGroupModule.selectedLsVersion]
		};
	}

	get persistedCurrentPage() {
		return this.currentPage;
	}

	formatData(data) {
		return data.transitions.map((tansition) => ({
			...tansition,
			title: pureRichText(tansition.text),
			versionGroupName: this.versionGroups.find((version) => version.id == tansition.versionGroupId)?.name,
			durationTimeString: toTimeString(tansition.duration)
		}));
	}

	@Watch("CommonEntitiesModule.versionGroups")
	reloadGrid() {
		if (this.gridCompRef) {
			this.gridCompRef.reload();
			this.gridCompRef.setCurrentPage(1);
		}
	}

	showLessonPlans(item) {
		if (item.totalCount) {
			CommonEntitiesModule.setSelectedEntity(item);
			CommonEntitiesModule.setUsageModalVisible(true);
		}
	}

	editTransition(item) {
		CommonEntitiesModule.setIsEdit(true);
		CommonEntitiesModule.setSelectedEntity(item);
		CommonEntitiesModule.setVisibleModal(true);
	}

	onRemove(item) {
		const content =
			item.lessonPlanVersions && item.lessonPlanVersions.length
				? this.localizedString(CommonEntitiesLocale.CommonHasAssociatedLessonPlanDescrition)
				: this.localizedString(CommonEntitiesLocale.CommonNoAssociatedDeleteTransition);
		Modal.confirm({
			class: "delete-transition",
			title: this.localizedString(CommonEntitiesLocale.CommonRemoveTransition),
			content: content,
			okText: this.localizedString(CommonLocale.CommonOkButtonText),
			cancelText: this.localizedString(CommonLocale.CommonCancelButtonText),
			onOk: () => {
				CommonEntitiesModule.deleteTransition(item && item.id);
			},
			onCancel: () => {}
		});
	}
}
